"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _Dispatch = require("crm_data/dispatch/Dispatch");

function _default(actionTypes) {
  var MOVED = actionTypes.MOVED;
  return {
    moveResult: function moveResult(key, searchQuery, from, to, id, toIndex) {
      id = parseInt(id, 10);
      return (0, _Dispatch.dispatchQueue)(MOVED, {
        key: key,
        searchQuery: searchQuery,
        from: from,
        to: to,
        id: id,
        toIndex: toIndex
      }).done();
    }
  };
}

module.exports = exports.default;